var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4063_4690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1864 16.0271C20.5413 17.7753 19.5657 19.2955 18.2864 20.5448C16.8301 21.9668 14.9233 23.0968 12.6187 23.9028C12.5431 23.9292 12.4642 23.9508 12.3849 23.9667C12.2802 23.9874 12.1736 23.9986 12.0679 24H12.0472C11.9346 24 11.8215 23.9887 11.7092 23.9667C11.6299 23.9508 11.5521 23.9292 11.4769 23.9033C9.16956 23.0986 7.26031 21.9692 5.80261 20.5472C4.5227 19.2979 3.5473 17.7786 2.90313 16.0304C1.7318 12.8516 1.79846 9.34993 1.85211 6.53596L1.85302 6.49275C1.86382 6.26038 1.87078 6.0163 1.87463 5.74677C1.89422 4.42347 2.94634 3.32868 4.26983 3.25489C7.02923 3.1009 9.16388 2.20093 10.9878 0.42316L11.0037 0.408511C11.3066 0.13074 11.6882 -0.00549075 12.0679 0.000185551C12.4341 0.00494631 12.7989 0.140994 13.0909 0.408511L13.1065 0.42316C14.9308 2.20093 17.0654 3.1009 19.8248 3.25489C21.1483 3.32868 22.2005 4.42347 22.22 5.74677C22.2239 6.01814 22.2308 6.26185 22.2416 6.49275L22.2422 6.51106C22.2957 9.33033 22.3619 12.839 21.1864 16.0271Z",
    fill: "#73A7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1864 16.0271C20.5413 17.7753 19.5657 19.2955 18.2864 20.5448C16.8301 21.9668 14.9233 23.0968 12.6187 23.9028C12.5431 23.9292 12.4642 23.9508 12.3849 23.9667C12.2802 23.9874 12.1736 23.9986 12.0679 24V0.000183105C12.4341 0.00494386 12.7989 0.140991 13.0909 0.408509L13.1065 0.423157C14.9308 2.20093 17.0654 3.10089 19.8248 3.25489C21.1483 3.32868 22.2004 4.42347 22.22 5.74677C22.2239 6.01813 22.2308 6.26185 22.2416 6.49274L22.2422 6.51105C22.2957 9.33033 22.3619 12.839 21.1864 16.0271Z",
    fill: "#4486E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0282 12.0009C18.0282 15.2918 15.3561 17.9707 12.0679 17.9824H12.0469C8.74896 17.9824 6.06537 15.299 6.06537 12.0009C6.06537 8.70296 8.74896 6.01955 12.0469 6.01955H12.0679C15.3561 6.03127 18.0282 8.7101 18.0282 12.0009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0282 12.0009C18.0282 15.2918 15.3561 17.9707 12.0679 17.9824V6.01955C15.3561 6.03127 18.0282 8.7101 18.0282 12.0009Z",
    fill: "#E1EBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7618 11.1396L12.0679 13.8339L11.4858 14.416C11.3483 14.5535 11.1679 14.6221 10.9878 14.6221C10.8074 14.6221 10.6272 14.5535 10.4895 14.416L9.23801 13.1639C8.96298 12.8889 8.96298 12.4434 9.23801 12.1682C9.51267 11.8931 9.95871 11.8931 10.2337 12.1682L10.9878 12.9222L13.766 10.1439C14.0411 9.86871 14.4871 9.86871 14.7618 10.1439C15.0368 10.4189 15.0368 10.865 14.7618 11.1396Z",
    fill: "#ABCDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7618 11.1396L12.0679 13.8339V11.8419L13.7661 10.1439C14.0411 9.86871 14.4871 9.86871 14.7618 10.1439C15.0368 10.4189 15.0368 10.865 14.7618 11.1396Z",
    fill: "#73A7F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4063_4690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.ce17e0d900adbca57cbc0603590b3fb0.svg";
export { ForwardRef as ReactComponent };